@if (showSuccess()) {
  <selfservice-success [message]="successMessage()" />
} @else {
  <ng-container [ngTemplateOutlet]="currentTemplate()" />

  @if (hasErrors()) {
    <div class="dialog__error dialog__error--margin-x">
      <ul>
        @for (e of errors(); track $index) {
          <li>{{ e.msg }}</li>
        }
      </ul>
    </div>
  }

  <div class="dialog__footer dialog__footer--center dialog__footer--border">
    <div class="dialog__footer-text">
      <selfservice-authentication-box />
    </div>
    <div class="button__flex">
      @if (firstStep()) {
        <button class="button button--secondary" mat-dialog-close>{{ "Global.Action.Cancel" | translate }}</button>
      } @else {
        <button class="button button--secondary" (click)="prev()" [class.button--disabled]="loading()">
          {{ "Global.Action.Back" | translate }}
        </button>
      }
      @if (!lastStep()) {
        <button (click)="next()" class="button" [class.button--disabled]="!canContinueOnStep()">
          {{ "Global.Action.Continue" | translate }}
        </button>
      } @else if (canConfirm()) {
        <button class="button" (click)="submit()" [class.loading]="loading()">
          <svg-icon src="assets/images/icons/loader.svg" class="button__loader"></svg-icon>
          <span>{{ "Global.Action.Confirm" | translate }}</span>
        </button>
      }
    </div>
  </div>
}
